import { render, staticRenderFns } from "./ScenarioHistoricalOverview.vue?vue&type=template&id=38a80f0e&scoped=true&"
import script from "./ScenarioHistoricalOverview.vue?vue&type=script&lang=js&"
export * from "./ScenarioHistoricalOverview.vue?vue&type=script&lang=js&"
import style0 from "../../Style/scenario-historical-overview.scss?vue&type=style&index=0&id=38a80f0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a80f0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a80f0e')) {
      api.createRecord('38a80f0e', component.options)
    } else {
      api.reload('38a80f0e', component.options)
    }
    module.hot.accept("./ScenarioHistoricalOverview.vue?vue&type=template&id=38a80f0e&scoped=true&", function () {
      api.rerender('38a80f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/Overview/ScenarioHistoricalOverview.vue"
export default component.exports